import { Vue, Component } from 'vue-property-decorator';
import { Form } from 'element-ui';
import { ILOGPRE } from '@/types/base.d';
import { IOrgForm } from '@/types/org.d';
import api from '@/api/org';

@Component
export default class formMixin extends Vue {
  public log: ILOGPRE = {
    name: '机构管理 - 模态框 -',
    component: 'org/manage/components/bModal',
  };

  public form: IOrgForm = {
    orgTitle: '',
    loginName: '',
    orgBackup: '',
  }

  private loading: boolean = false;

  public $refs!: {
    form: Form,
  };

  private rules: any = {
    orgTitle: [
      { required: true, message: '机构名称不能为空' },
    ],
    loginName: [
      { required: true, message: '登录名称不能为空' },
    ],
  };

  /* eslint-disable class-methods-use-this */
  reset(close: boolean, refrsh: boolean) {}

  /**
   * @author liangyongmou
   * @desc 重置表单
   * @param 空
   */
  resetForm() {
    this.$refs.form.resetFields();
  }

  /**
   * @author liangyongmou
   * @desc 添加/编辑机构信息
   * @param { string } title 标题
   */
  submit(title: string) {
    this.loading = true;
    this.$refs.form.validate((valid: boolean) => {
      if (valid) {
        this.$log({
          title: `${this.log.name}提交`,
          component: this.log.component,
        });
        if (title.includes('编辑')) {
          api.editOrg(this.form).then(() => {
            this.reset(true, true);
            this.loading = false;
          /* eslint-disable no-return-assign */
          }).catch(() => (this.loading = false));
        } else {
          api.addOrg(this.form).then(() => {
            this.reset(true, true);
            this.loading = false;
          /* eslint-disable no-return-assign */
          }).catch(() => (this.loading = false));
        }
      } else this.loading = false;
    });
  }
}
